import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { Branch } from "@/types";

export function useBranches() {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("branches")
        .select(
          "id, name, code, address, phone, rnc, email, schedule, logo_url, facebook, instagram, tiktok, youtube, whatsapp, invoice_prefix, invoice_sequence, active, created_at",
        )
        .order("created_at", { ascending: true });

      if (queryError) {
        setError("No se pudieron cargar las sucursales.");
        setBranches([]);
        return;
      }
      setBranches((data ?? []) as Branch[]);
    } catch {
      setError("No se pudieron cargar las sucursales.");
      setBranches([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { branches, loading, error, reload: load };
}